import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=30072b8b&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports